<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowHaOpportunitiesByAudiologist',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_ha_appointments', throughMonth),
          this.getYtdByField(yearObj, 'number_providers', throughMonth),
        );
      },
    },
  };
</script>
